import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import MessageIcon from '@mui/icons-material/Message';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Button, Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {styled} from '@mui/material/styles';
import parse from 'html-react-parser';
import * as React from 'react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from '../../axios';
import {shortDateFormat} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import LikeButton from '../like/LikeButtonActu';
import Tags from '../tag/Tag';
import ActualityComment from './ActualityComment';
import './actuality.less';
import {useComments} from './hooks/useComments';
import {useLikeCount} from './hooks/useLike';
import CloseIcon from '@mui/icons-material/Close';

const Img = styled('img')({
  top: '33px',
  left: '34px',
  display: 'block',
  width: '100%',
  height: 'auto',
  borderRadius: '5px',
});

const ActualityExpandMore = ({
  actuality,
  expandMore,
  handleToggleClick,
  showCommunityInfo,
}) => {
  const [expandComment, setExpandComment] = useState(false);

  const handleToggleComment = () => {
    setExpandComment(!expandComment);
  };
  const {commentCount} = useComments(actuality.id);
  const {likeCount} = useLikeCount('actuality', actuality.id);

  const navigate = useNavigate();

  const {mode} = useDarkMode();

  return (
    <Grid item xs={12} sm container>
      <Grid item xs container>
        <Grid item xs>
          <Typography
            variant="subtitle1"
            component="div"
            className={'actualityHeaderContainer'}
            style={{backgroundColor: mode.settings.cardBackgroundColor}}>
            {showCommunityInfo ? (
              <Typography className={'actualityHeaderContainer'}>
                <Typography
                  component={'div'}
                  className={'actualityCommunityName'}
                  style={{color: mode.settings.textColor6}}>
                  {actuality.community.name}
                </Typography>
                <Button
                  className="btn-gradient"
                  variant="contained"
                  size="large"
                  endIcon={
                    <RemoveRedEyeIcon
                      role={'img'}
                      aria-label="Voir le détail de l'actualité"
                    />
                  }
                  sx={{width: 75, height: 37, marginRight: 2}}
                  onClick={() =>
                    navigate(`/community/${actuality.community.id}`)
                  }>
                  <Typography variant={'subtitle3'}>Voir</Typography>
                </Button>
              </Typography>
            ) : (
              ''
            )}
            <Tags tags={actuality.tags}></Tags>
          </Typography>
          <Typography variant="h3" className="communityTitleContainer">
            <Typography color={mode.settings.textColor3} variant={'subtitle7'}>
              {actuality.title.text}
            </Typography>
            <Button
              className="buttonOhs"
              startIcon={<CloseIcon />}
              aria-label="Fermer le d&eacutetail"
              sx={{
                display : {xs : "none", md : "flex" , lg : "flex"},
                minWidth : '236px'
              }}
              onClick={handleToggleClick}
            >
              <Typography variant={'subtitle3'}>Fermer le détail</Typography>
            </Button>
          </Typography>
          <Typography
            variant="subtitle1"
            className="communityAttributesContainer"
            component="div"
            style={{color: mode.settings.textColor6}}>
            <CalendarMonthIcon
              className="communityIcon"
              role={'img'}
              aria-label="Date de publication de l'actualité"></CalendarMonthIcon>
            <span className="communityAttributes">
              {shortDateFormat(actuality.published_date)}
            </span>
            <FavoriteBorderIcon
              className="communityIcon"
              role={'img'}
              aria-label="Nombre de j'aime de l'actualité"></FavoriteBorderIcon>
            <span className="communityAttributes">
              {likeCount} J'aime{likeCount > 1 ? 's' : ''}
            </span>
            <MessageIcon
              className="communityIcon"
              role={'img'}
              style={{marginTop: 'auto'}}
              aria-label="Nombre de commentaire de l'actualité"></MessageIcon>
            <span className="communityAttributes">
              {commentCount} Commentaire{commentCount > 1 ? 's' : ''}
            </span>
            <FilePresentIcon
              className="communityIcon"
              role={'img'}
              aria-label="Nombre de document de l'actualité"></FilePresentIcon>
            <span className="communityAttributes">0 Document joint</span>
          </Typography>
          <Grid item xs={12} sm container className="communityImg">
            <Img
              id="expandMoreImage"
              alt={actuality.image.alternativeText}
              src={`${axios.defaults.apiBaseURL}/${actuality.image.uri}`}
              role="img"
              longdesc={'#communityDescription'}
            />
          </Grid>
          <Typography
            className="communityDescription"
            color={mode.settings.textColor3}
            variant={'subtitle3'}>
            <span>{parse(actuality.description.text)}</span>
          </Typography>
          <Stack
            direction="row"
            justifyContent="left"
            alignItems="center"
            sx={{color: '#3E9FDD', cursor: 'pointer'}}
            onClick={handleToggleClick}>
            <ArrowDropUpIcon
              className="linkArrow"
              aria-label="Voir moins"
              sx={{marginLeft: -0.4}}
            />
            <Typography variant={'subtitle1'}>
              {expandMore ? 'Afficher moins' : "Lire l'article en entier"}
            </Typography>
          </Stack>
          <Stack
              variant="subtitle1"
              className="communityButtonContainer"
              component={'div'}
              style={{backgroundColor: mode.settings.card3BackgroundColor}}
              gap={2}
              direction={"row"}
              flexWrap={"wrap"}
              sx={{
                justifyContent : {xs :"center", md:"center", lg:"space-between"}
              }}
          >
            <LikeButton type={'actuality'} contentId={actuality.id} />
            {expandComment ? (
              <Button
                className="buttonOhs"
                startIcon={
                  <VisibilityOffIcon
                    role={'img'}
                    aria-label="Masquer les commentaires"
                  />
                }
                onClick={handleToggleComment}>
                Masquer les commentaires
              </Button>
            ) : (
              <Button
                className="buttonOhs"
                startIcon={
                  <RemoveRedEyeIcon
                    role={'img'}
                    aria-label="Afficher les commentaires"
                  />
                }
                onClick={handleToggleComment}>
                <Typography variant={'subtitle1'}>
                  Afficher les commentaires
                </Typography>
              </Button>
            )}
          </Stack>
          <Typography>
            {expandComment ? (
              <ActualityComment actualityId={actuality.id} />
            ) : (
              <div></div>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ActualityExpandMore;
